import {withProps} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import withDialogContainer from '../../../../hocs/withDialogContainer'
import type {State} from '../../../../reducers/types'
import {withLocation} from '../../../../routes'
import {getExtensionEndpoint, getIsSakuraUI} from '../../../../selectors'
import {DialogType} from '../../../../types'
import {queryToObject} from '../../../../utils/queryParams'

import CompareBuildDialog from './CompareBuildDialog'

const mapStateToProps = (state: State) => ({
  endpoint: getExtensionEndpoint(state, 'builds-diff')?.endpoint,
  isSakuraUI: getIsSakuraUI(state),
})

export default compose(
  withLocation,
  withProps(({location}) => ({
    currentTab: queryToObject(location?.search).tab,
  })),
  withDialogContainer(DialogType.COMPARE),
  connect(mapStateToProps),
)(CompareBuildDialog)
